import { defineComponent as _defineComponent } from 'vue'
import {computed, ref} from 'vue';
import Vue from 'vue';
import {QrCode} from "lucide-vue"
import VModal from 'vue-js-modal';
import QrcodeStyling from "@/components/other/QrcodeStyling.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CryptoTxUrlWithQrCode',
  props: {
  url: {type: String, required: true},
  txid: {type: String, required: true},
},
  setup(__props) {

const props = __props;

Vue.use(VModal);



const txUrl = computed(() => {
  return props.url;
})

const txId = computed(() => {
  return props.txid;
})

const modalRef = ref(null)

const modalName = computed(() => {
  return 'qrcode-modal' + txId.value;
})

const showQrCode = () => {
  //console.log(modalRef.value);
  modalRef.value.$modal.show(modalName.value);
}

const qrcodeConfig = {
    width: 250,
    height: 250,
    type: "svg",
    margin: 0,
    //data: "https://www.facebook.com/",
    // image: 'data:image/svg+xml;base64,' + CapLogoImage.logoWorking, //"https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg",
    dotsOptions: {
      color: "#627f23", //93bb36
      type: "square"
    },
    backgroundOptions: {
      color: "#ffffff",
    },
    cornersSquareOptions: {
      "type": "extra-rounded",
      //"color": "#000000"
    },
    imageOptions: {
      hideBackgroundDots: true,
      crossOrigin: "anonymous",
      imageSize: 0.5,
      margin: 0
    },
    qrOptions: {typeNumber: "0", mode: "Byte", errorCorrectionLevel: "H"}
}

return { __sfc: true,props, txUrl, txId, modalRef, modalName, showQrCode, qrcodeConfig, QrCode, QrcodeStyling }
}

})